export default "__VITE_ASSET__B9B9AzCI__"